import EmptyRole from './EmptyRole'
export default EmptyRole
